(() => {
  'use strict';
  const VERSION = 6;
  if (window.WUBPdpTrust?.version === VERSION) return;

  const i18n = window.WUB?.i18n || {};
  const stockI18n = i18n.stock || {};
  const interpolate = window.WUB?.interpolate || ((template, values = {}) => String(template || '').replace(/\{\{\s*([a-zA-Z0-9_]+)\s*\}\}/g, (match, key) => Object.prototype.hasOwnProperty.call(values, key) ? String(values[key]) : match));
  const nodes = () => Array.from(document.querySelectorAll('[data-wub-pdp-delivery]'));

  function currentControllerVariant(node) {
    const sectionId = node?.dataset?.sectionId || '';
    if (!sectionId) return null;
    return window.WUBProductController?.getState?.(sectionId)?.variant || null;
  }

  function normalizeVariant(variant, node) {
    const activeVariant = variant || currentControllerVariant(node);
    if (activeVariant) return activeVariant;
    return {
      inventory_management: node.dataset.inventoryManagement || null,
      inventory_policy: node.dataset.inventoryPolicy || '',
      inventory_quantity: Number(node.dataset.inventoryQuantity || 0),
      available: node.dataset.available !== 'false'
    };
  }

  function deliveryPromise() {
    return window.WUBPromise?.getPromise?.()?.delivery || window.WUBDelivery?.getPromise?.() || null;
  }

  function resolveState(variant, node) {
    const management = variant.inventory_management ?? variant.inventoryManagement ?? null;
    const policy = variant.inventory_policy ?? variant.inventoryPolicy ?? '';
    const quantity = Number(variant.inventory_quantity ?? variant.inventoryQuantity ?? 0);
    const available = variant.available !== false;
    const threshold = Number(node.dataset.lowStockThreshold || 6);

    if (!available) return { copy: stockI18n.temporarilySoldOut || 'Temporarily sold out', tone: 'danger', quantity, showMeta: false, lowStock: false };

    if (management && quantity <= 0) {
      if (policy === 'continue') {
        return {
          copy: node.dataset.backorderCopy || stockI18n.backorder || 'Available to order with lead time',
          tone: 'warning',
          quantity,
          showMeta: true,
          lowStock: false
        };
      }
      return { copy: stockI18n.temporarilySoldOut || 'Temporarily sold out', tone: 'danger', quantity, showMeta: false, lowStock: false };
    }

    const promise = deliveryPromise();
    return {
      copy: promise?.enabled ? promise.shipCopy : (stockI18n.inStock || 'In stock'),
      tone: promise?.shippingToday ? 'success' : 'neutral',
      quantity,
      showMeta: true,
      lowStock: Boolean(management && quantity > 0 && quantity <= threshold)
    };
  }

  function paint(node, variant) {
    const copyNode = node.querySelector('[data-wub-pdp-delivery-copy]');
    const metaNode = node.querySelector('[data-wub-pdp-delivery-meta]');
    const stockNode = node.querySelector('[data-wub-pdp-low-stock]');
    const separatorNode = node.querySelector('[data-wub-pdp-meta-separator]');
    const shippingNode = node.querySelector('[data-wub-pdp-free-shipping]');
    if (!copyNode) return;

    const state = resolveState(normalizeVariant(variant, node), node);
    const shippingCopy = node.dataset.freeShipping || '';
    copyNode.textContent = state.copy;
    copyNode.className = `wub-pdp-trust__delivery-copy is-${state.tone}`;
    node.dataset.tone = state.tone;

    if (stockNode) {
      stockNode.textContent = state.lowStock
        ? interpolate(stockI18n.lowStock || 'Only {{ quantity }} left in stock', { quantity: state.quantity })
        : '';
      stockNode.hidden = !state.lowStock;
    }
    if (shippingNode) {
      shippingNode.textContent = shippingCopy;
      shippingNode.hidden = !shippingCopy || !state.showMeta;
    }
    if (separatorNode) separatorNode.hidden = !(state.lowStock && shippingCopy && state.showMeta);
    if (metaNode) metaNode.hidden = !state.showMeta || (!state.lowStock && !shippingCopy);
  }

  function paintAll(variant = null, sectionId = null) {
    nodes().forEach((node) => {
      if (sectionId && node.dataset.sectionId && String(sectionId) !== String(node.dataset.sectionId)) return;
      paint(node, variant);
    });
  }

  paintAll();
  document.addEventListener('wub:product-state-change', (event) => {
    const detail = event.detail || {};
    paintAll(detail.variant || null, detail.sectionId || null);
  });
  document.addEventListener('wub:promise-synced', () => paintAll());

  window.WUBPdpTrust = Object.freeze({ version: VERSION, paintAll });
})();
